module.exports = __webpack_public_path__ + "static/material-ui-logo-d2b1e19091a3530dfb8bec06b5a926dc.png";